
export enum DisputeShipmentPaymentStatusCd {
	OPEN = 'Open',
	PAID_IN_FULL = 'PaidInFull'}

